import React, { useState, useEffect } from 'react';

const GDPRBanner = ({ onAccept }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('gdpr_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('gdpr_consent', 'accepted');
    setVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('gdpr_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-[#0f1a2e] text-white p-4 shadow-lg z-50 border-t border-[#2a3a5a]"
      data-testid="gdpr-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-300 text-center sm:text-left">
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm border border-[#2a3a5a] rounded-lg hover:bg-[#1a2744] transition-colors text-gray-300"
            data-testid="gdpr-decline-btn"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-[#c23a4a] hover:bg-[#a83240] rounded-lg transition-colors font-medium text-white"
            data-testid="gdpr-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default GDPRBanner;
